import { HtmlGraphicObject } from "./html-graphic-object";
import { NamedObjectContainer } from "../named-object-container";
import { WebglObjectGroup } from "../webgl/webgl-object-group";
import { FixedDimension } from "../utils/fixed-dimension";
import { PercentDimension } from "../utils/percent-dimension";
import { getPpi } from "../utils/get-ppi";
import InitProgram from "../webgl/init-program.js";

export class GraphicCanvas extends HtmlGraphicObject {
  constructor(settings) {
    super(settings);
    this.settings.canvas = this;
    this.settings.transfer.push({ path: "canvas", level: -1 });
    this.settings.drawEnabled = true;
    HtmlGraphicObject.setHtmlObject(this.settings, document.createElement("canvas"));
    this.settings.htmlObject.ref.setAttribute("width", `${this.settings.sizeInPixels.width}px`);
    this.settings.htmlObject.ref.setAttribute("height", `${this.settings.sizeInPixels.height}px`);
    this.settings.htmlObject.ref.setAttribute(
      "style",
      `left: ${this.settings.absoluteLocation.x}px; top: ${this.settings.absoluteLocation.y}px; margin: ${this.settings.marginInPixels.top}px, ${this.settings.marginInPixels.right}px, ${this.settings.marginInPixels.bottom}px, ${this.settings.marginInPixels.left}px; position: absolute; z-index: auto; pointer-events: none;`
    );

    const gl = this.settings.htmlObject.ref.getContext("webgl", {
      antialias: false,
      premultipliedAlpha: false
    });
    this.settings.gl = gl;

    this.settings.transfer.push({ path: "gl", level: -1 });
    this.settings.program = new InitProgram(this.settings.gl);
    this.settings.transfer.push({ path: "program", level: -1 });

    this.settings.debug.boxFillColor = "magenta";
    this.settings.debug.boxOutline = "2px solid #880088";

    this.settings.ppi = getPpi();
    this.settings.ppcm = this.settings.ppi / 2.54;
    this.settings.transfer.push({ path: "ppi", level: -1 });
    this.settings.transfer.push({ path: "ppcm", level: -1 });

    this.webglItems = new WebglObjectGroup({
      location: {
        x: new FixedDimension(0),
        y: new FixedDimension(0)
      },
      size: {
        width: new PercentDimension(1),
        height: new PercentDimension(1)
      },
      parent: {
        ref: this
      },
      itemsContainer: new NamedObjectContainer("webglItems")
    });
  }

  addItem(item) {
    this.webglItems.itemsContainer.add(item);
  }

  createBorders() {
    super.createBorders();
    this.webglItems.setParentSize(this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
    this.webglItems.createBorders();
  }

  createHtmlBorders() {
    super.createHtmlBorders();
    this.settings.htmlObject.ref.style.left = `${this.settings.htmlObject.absoluteLocation.x}px`;
    this.settings.htmlObject.ref.style.top = `${this.settings.htmlObject.absoluteLocation.y}px`;
    this.settings.htmlObject.ref.setAttribute("width", `${this.settings.htmlObject.sizeInPixels.width}px`);
    this.settings.htmlObject.ref.setAttribute("height", `${this.settings.htmlObject.sizeInPixels.height}px`);
  }

  setDebugMode(debugSettings) {
    super.setDebugMode(debugSettings);
    if (debugSettings.fillHtmlElements) {
      this.settings.htmlObject.ref.style.backgroundColor = this.settings.debug.boxFillColor;
    }
    this.webglItems.setDebugMode(debugSettings);
  }

  draw() {
    if (!this.settings.drawEnabled) {
      return;
    }
    this.settings.gl.viewport(0, 0, this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
    if (this.settings.backgroundColor !== undefined) {
      this.settings.gl.clearColor(
        this.settings.backgroundColor[0],
        this.settings.backgroundColor[1],
        this.settings.backgroundColor[2],
        this.settings.backgroundColor[3]
      );
    }
    this.settings.gl.clear(this.settings.gl.COLOR_BUFFER_BIT);
    this.webglItems.draw(this.settings.gl, this.settings.program);
    //this.drawTimer = requestAnimationFrame(this.draw.bind(this));
  }

  refreshGraphics() {
    requestAnimationFrame(this.draw.bind(this));
  }
}
